module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/平板.b2125e64.png";